import styled from 'styled-components';

const StyledWrapper = styled.div`
	position: absolute;
	left: 50%;
	transform: translate(-50%, 200%);
	transition:
		opacity 0.3s ease,
		transform 0.3s ease,
		bottom 0.3s ease;

	&.action-button-enter {
		opacity: 0;
		transform: translate(-50%, 200%);
	}

	&.action-button-enter-active,
	&.action-button-enter-done,
	&.action-button-exit {
		opacity: 1;
		transform: translate(-50%, 0);
	}

	&.action-button-exit-active {
		opacity: 0;
		transform: translate(-50%, 200%);
	}
`;

const StyledContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	padding: 10px;
	border-radius: 10px;
	background-color: rgba(0, 0, 0, 0.5);
	cursor: pointer;
	user-select: none;
	-webkit-user-select: none;
	transition: background-color 0.3s ease;

	p {
		font-family: 'GT Walsheim Pro';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
		transition: color 0.3s ease;
		user-select: none;
		pointer-events: none;
	}
`;

export { StyledContainer, StyledWrapper };
